// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__1xEFa","content":"TermsOfServicePage_content__1lBtV"};